import { EinzaGraphiQLService } from "@/services/einzaGraphiQL"

/**
 * Method to retrieve customer revenue data based on customer number and year
 *
 * @param {string} id
 * @param {int} key
 *
 * @return {Promise<customerRevenue>|null}
 */
export const getCustomerRevenueData = async (customerNumber, year) => {
  if (typeof customerNumber !== "string" && customerNumber.length <= 0) return null

  const currentYear = year && year > 0 ? year : new Date().getFullYear()
  const lastYear = currentYear - 1
  const fields = ["year", "revenue"]

  const currentYearVariables = { customerNumber, year: currentYear }
  const lastYearVariables = { customerNumber, year: lastYear }

  const graphiQLQueryObject = [
    {
      method: "currentYearRevenue: customerStatsByArticleMainGroup",
      variables: currentYearVariables,
      fields,
    },
    {
      method: "lastYearRevenue: customerStatsByArticleMainGroup",
      variables: lastYearVariables,
      fields,
    },
  ]

  try {
    const mappedQuery = EinzaGraphiQLService.formQuery(graphiQLQueryObject)
    const queryResponse = (await EinzaGraphiQLService.getData(mappedQuery))?.data

    if (!queryResponse) throw new Error("Data retrieval for stats projection failed")

    const { currentYearRevenue, lastYearRevenue } = queryResponse

    const currentYearRevenueData = {
      year: currentYear,
      revenue: currentYearRevenue.reduce((acumulator, { revenue }) => acumulator + revenue, 0),
      target: null,
    }

    const lastYearRevenueData = {
      year: lastYear,
      revenue: lastYearRevenue.reduce((acumulator, { revenue }) => acumulator + revenue, 0),
      target: null,
    }

    return {
      currentYearRevenue: currentYearRevenueData,
      lastYearRevenue: lastYearRevenueData,
    }
  } catch (error) {
    console.error("Error in getCustomerRevenueData", { error })

    return {
      currentYearRevenue: null,
      lastYearRevenue: null,
    }
  }
}
